import { BaseActionObject, StateNodeConfig } from "xstate4"
import {
  Context,
  GetOrgClassesWithTeachersResponse,
  Transitions
} from "../../types"
import { baseTransition } from "../transitions"

export const loadingState: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  on: {
    UPDATE_PROPERTY_FILTERS: {
      // Start fetching data after some delay.
      actions: ["setPropertyFilters", "cancelFetch", "updateFetch"]
    },
    SEARCH: {
      // Start fetching data after some delay.
      actions: ["setSearchData", "cancelFetch", "updateFetch"]
    }
  },
  ...baseTransition<GetOrgClassesWithTeachersResponse>(
    "getClassRecords",
    "getClassRecords",
    "backToPrevious",
    {
      loadingState: "data",
      onSuccess: (ctx, evt) => ({
        teachers: evt.data.teachers,
        classTableContent: evt.data.orgClasses.classes,
        canAddClass: evt.data.orgClasses.meta.canAddClass,
        availableEocSubjects: evt.data.orgClasses.meta.availableEocSubjects,
        page: evt.data.orgClasses.meta.page,
        pageSize: evt.data.orgClasses.meta.pageSize,
        hasNextPage: evt.data.orgClasses.meta.hasNextPage,
        hasPrevPage: evt.data.orgClasses.meta.hasPrevPage,
        // If details tray is open and some record selected, update it from new data.
        ...(ctx.openDetailsTray &&
          ctx.selectedClassRecord && {
            selectedClassRecord:
              evt.data.orgClasses.classes.find(
                orgClass => orgClass.id === ctx.selectedClassRecord.id
              ) ?? ctx.selectedClassRecord
          })
      }),
      onError: (_ctx, _evt) => ({
        snackbar: {
          message:
            "An error occurred. Unable to load classes data. Please try again or if the problem persists, please contact customer support.",
          withUndo: false,
          error: true
        }
      })
    }
  )
}
